import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { actions } from 'builder/modules/panel'
import { actions as userActions } from 'builder/modules/user'
import { useUser } from 'builder/hooks/useUser'

type GetPromotionActionsProps = {
  handleGetPromotionPage: () => void
  handleOpenBookCoach: () => void
}

export const useGetPromotionActions = (): GetPromotionActionsProps => {
  const user = useUser()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleGetPromotionPage = () => {
    if (!user?.uiStates?.promotionPlanSeen) {
      dispatch(actions.setUIStatesConfigStatus({ promotion_plan_seen: true }))
      dispatch(userActions.setUIUserState({ promotionPlanSeen: true }))
    }
    navigate('/career-plans/path-to-promotion')
  }

  const handleOpenBookCoach = () => {
    navigate('/career-coaching')
  }

  return {
    handleGetPromotionPage,
    handleOpenBookCoach,
  }
}
